import React from "react";
import type { AnalyticsBrowser } from "@segment/analytics-next";

import {
  segmentInstance,
  segmentWriteKey,
} from "@lib/analytics/segmentInstance";

interface ISegmentContext {
  analytics: AnalyticsBrowser;
  writeKey: string;
  cdnURL?: string;
}

const SegmentContext = React.createContext<ISegmentContext | undefined>(
  undefined,
);

interface ISegmentProvider {
  children?: React.ReactNode;
}

// Consumes the module-level singleton in `segmentInstance.ts` instead
// of creating its own AnalyticsBrowser. Prevents the double-load that
// would otherwise happen when non-React code in main.tsx
// (fireEarlyCheckoutTracking) also needs access to Segment.
export const SegmentProvider: React.FC<ISegmentProvider> = ({ children }) => {
  return (
    <SegmentContext.Provider
      value={{
        analytics: segmentInstance,
        writeKey: segmentWriteKey,
      }}
    >
      {children}
    </SegmentContext.Provider>
  );
};

// Create an analytics hook that we can use with other components.
export const useSegment = () => {
  const result = React.useContext(SegmentContext);

  if (!result) {
    throw new Error("Context used outside of its Provider!");
  }
  return result;
};
